import { getNotices } from './notices';
import { getSekki } from './sekki';
import { getTermsAndConditions } from './termsAndConditions';

export const cmsApi = {
  getNotices,
  getSekki,
  getTermsAndConditions
};
